module.exports = "<label :for=\"id\" class=\"weui_cell weui_check_label\">\n  <cell-header>\n    <input type=\"checkbox\" :name=\"name\" class=\"weui_check\" :id=\"id\" :value=\"value\" v-model=\"checked\">\n    <span class=\"weui_icon_checked\"></span>\n  </cell-header>\n  <cell-body>{{{label}}}</cell-body>\n</label>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./components/cells/checkbox-cell.vue
 ** module id = 79
 ** module chunks = 0
 **/